import Cookies from 'js-cookie'

const TokenKey = 'user_token'
const IdKey = 'user_msg'
//------------token
export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
//---------------用户信息
export function setUserMsg(id) {
  return Cookies.set(IdKey, id)
}

export function getUserMsg() {
  return Cookies.set(IdKey)
}
export function removeUserMsg() {
  return Cookies.remove(IdKey)
}
